import PropTypes from 'prop-types';
import { Component } from 'react';

import { defineMessages, injectIntl } from 'react-intl';

import { Link } from 'react-router-dom';

import { WordmarkLogo } from 'mastodon/components/logo';
import NavigationPortal from 'mastodon/components/navigation_portal';
import { transientSingleColumn } from 'mastodon/is_mobile';

import ColumnLink from './column_link';
import DisabledAccountBanner from './disabled_account_banner';
import FollowRequestsColumnLink from './follow_requests_column_link';
import NotificationsCounterIcon from './notifications_counter_icon';
import SignInBanner from './sign_in_banner';

import UnansweredMentionsCounterIcon from './unanswered_mentions_counter_icon';

const messages = defineMessages({
  home: { id: 'tabs_bar.home', defaultMessage: 'Home' },
  notifications: { id: 'tabs_bar.notifications', defaultMessage: 'Notifications' },
  firehose: { id: 'column.firehose', defaultMessage: 'Live feeds' },
  direct: { id: 'navigation_bar.direct', defaultMessage: 'Private mentions' },
  favourites: { id: 'navigation_bar.favourites', defaultMessage: 'Favorites' },
  bookmarks: { id: 'navigation_bar.bookmarks', defaultMessage: 'Bookmarks' },
  lists: { id: 'navigation_bar.lists', defaultMessage: 'Lists' },
  preferences: { id: 'navigation_bar.preferences', defaultMessage: 'Preferences' },
  followsAndFollowers: { id: 'navigation_bar.follows_and_followers', defaultMessage: 'Follows and followers' },
  about: { id: 'navigation_bar.about', defaultMessage: 'About' },
  advancedInterface: { id: 'navigation_bar.advanced_interface', defaultMessage: 'Open in advanced web interface' },
  openedInClassicInterface: { id: 'navigation_bar.opened_in_classic_interface', defaultMessage: 'Posts, accounts, and other specific pages are opened by default in the classic web interface.' },
});

class NavigationPanel extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired,
    identity: PropTypes.object.isRequired,
  };

  static propTypes = {
    intl: PropTypes.object.isRequired,
  };

  isFirehoseActive = (match, location) => {
    return match || location.pathname.startsWith('/public');
  };

  render () {
    const { intl } = this.props;
    const { signedIn, disabledAccountId } = this.context.identity;

    return (
      <div className='navigation-panel'>
        <div className='navigation-panel__logo'>
          <Link to='/' className='column-link column-link--logo'><WordmarkLogo /></Link>

          {transientSingleColumn ? (
            <div class='switch-to-advanced'>
              {intl.formatMessage(messages.openedInClassicInterface)}
              {" "}
              <a href={`/deck${location.pathname}`} class='switch-to-advanced__toggle'>
                {intl.formatMessage(messages.advancedInterface)}
              </a>
            </div>
          ) : (
            <hr />
          )}
        </div>

        {signedIn && (
          <>
            <ColumnLink transparent to='/home' icon={<i className='fa fa-home fa-fw column-link__icon' />} text={intl.formatMessage(messages.home)} />
            <ColumnLink transparent to='/notifications' icon={<NotificationsCounterIcon className='column-link__icon' />} text={intl.formatMessage(messages.notifications)} />
            <FollowRequestsColumnLink />
          </>
        )}
        {(signedIn) && (
          <ColumnLink transparent to='/public/local' isActive={this.isFirehoseActive} icon={<i className='fa fa-hashtag fa-fw column-link__icon' />} text={intl.formatMessage(messages.firehose)} />
        )}

        {!signedIn && (
          <div className='navigation-panel__sign-in-banner'>
            { disabledAccountId ? <DisabledAccountBanner /> : <SignInBanner /> }
          </div>
        )}

        {signedIn && (
          <>
            <ColumnLink transparent to='/unanswered_mentions' icon={<UnansweredMentionsCounterIcon className='column-link__icon' />} text='답할 멘션' />
            <ColumnLink transparent to='/conversations' icon={<i className='fa fa-at fa-fw column-link__icon' />} text={intl.formatMessage(messages.direct)} />
            <ColumnLink transparent to='/bookmarks' icon={<i className='fa fa-bookmark fa-fw column-link__icon' />} text={intl.formatMessage(messages.bookmarks)} />
            <ColumnLink transparent to='/favourites' icon={<i className='fa fa-star fa-fw column-link__icon' />} text={intl.formatMessage(messages.favourites)} />

            <hr />

            <ColumnLink transparent href='/settings/preferences' icon={<i className='fa fa-cog fa-fw column-link__icon' />} text={intl.formatMessage(messages.preferences)} />
          </>
        )}

        <div className='navigation-panel__legal navigation-panel__legal--desktop-only'>
          <hr />
          <ColumnLink transparent href='https://docs.google.com/document/d/1xP3k4GOjNfNm31F4Pn_u2ruJqv35etwqlSxNQN4POdE/edit?tab=t.0' icon='map' text='아카이브' target='_blank' />
          <ColumnLink transparent href='https://docs.google.com/document/d/100Jn3EU3cOXGWLRza4fqgXvNPUm3MthKNqXdFRrHfgE/edit?usp=sharing' icon='address-card' text='주소록' target='_blank' />
          <ColumnLink transparent href='https://diasporashometown.life/@diaspora' icon='bullhorn' text='공지' target='_blank' />
        </div>
        <NavigationPortal />
      </div>
    );
  }

}

export default injectIntl(NavigationPanel);